import Modal from '../utils/Modal';

export default class OrderWithdrawal {

    static init($container) {
        $container.find('.js-order-withdrawal-button').each(function () {
            $(this).off('click', OrderWithdrawal.onButtonClick).on('click', OrderWithdrawal.onButtonClick);
        });
    };

    static onButtonClick(event) {
        event.preventDefault();

        naja.makeRequest(
            'GET',
            $(event.currentTarget).attr('href'),
            null,
            {
                history: false
            }
        ).then(function (response) {
            const modal = new Modal({
                title: response.title,
                body: response.content,
                cssClass: 'js-order-withdrawal-modal'
            });

            naja.uiHandler.bindUI(modal.getModal().get(0));
        });
    };

}

naja.uiHandler.addEventListener('interaction', (event) => {
    if (event.detail.element.closest('.order-withdrawal__form')) {
        event.detail.options.history = false;
        event.detail.options.orderWithdrawalInModal = event.detail.element.closest('.js-order-withdrawal-modal') !== null;
    }
});

// LoadingIndicator overwrites loaderElement on interaction, so the modal target is set later
naja.addEventListener('before', (event) => {
    if (event.detail.options.orderWithdrawalInModal) {
        event.detail.options.loaderElement = '.js-order-withdrawal-modal';
    }
});

naja.addEventListener('init', () => {
    OrderWithdrawal.init($('body'));
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    OrderWithdrawal.init($(event.detail.snippet));
});
